document.addEventListener("DOMContentLoaded", function() {

// ADD MORE COUNTRIES HERE IF NEEDED
const blacklist = ['CA','HK', 'AU','JP', 'US-NQIB'];

const confirmButton = document.querySelector('.js-confirm');
const denyButton = document.querySelector('.js-deny');
const checkCountryButton = document.querySelector('.js-check-country');
const chooseCountrySelector = document.querySelector('.js-choose-country');
const chooseCountryView = document.querySelector('[data-view="choose-country"]');
const confirmMessageView = document.querySelector('[data-view="confirm-message"]');
const hasRestrictedContent = document.querySelector('[data-restricted-access="true"]');
const scrollTarget = document.querySelector('.header');

let state = {
  country: null,
  confirmed: false
}

const setActiveView = (t) => {
  let target = document.querySelector(t);
  target.classList.add('is-current');
  target.clientWidth;
  target.classList.remove('is-hidden');
  
  setTimeout( () => {
    target.classList.add('view-transition');
    scrollTarget.scrollIntoView({behavior: "smooth", block: "end"});
    console.log(scrollTarget)
  }, 10);
}

const init = () => {
   
  if (state.confirmed == false) {
    confirmButton.addEventListener('click', (e) => {
      state.confirmed = true;
      confirmMessageView.classList.remove('is-current');
      setActiveView('[data-view="access-granted"]');
    });
     denyButton.addEventListener('click', (e) => {
      state.confirmed = false;
      confirmMessageView.classList.remove('is-current');
      setActiveView('[data-view="access-denied"]');
    });
    
    
    checkCountryButton.addEventListener('click', (e) => {
      if (state.country !== null) {
        checkCountry();
      } else {
        alert('You must choose a country');
      }
    });
    
    chooseCountrySelector.addEventListener('change', (e) => {
      state.country = e.target.value;
    })
    setActiveView('[data-view="choose-country"]');
  } else {
    setActiveView('[data-view="access-granted"]');
  }
}

const checkCountry = () => {
  if (blacklist.includes(state.country)) {
    chooseCountryView.classList.remove('is-current');
    setActiveView('[data-view="access-denied"]');
  } else {
    chooseCountryView.classList.remove('is-current');
    setActiveView('[data-view="confirm-message"]');
  }
}

if (hasRestrictedContent !== null) {
    init();
    }
});